import React, { lazy, memo, Suspense } from "react"; // Import memo and useState
import styled from "styled-components";
import TotalProperty from "./thirdRow/totalProperty";
import AnimatedBox from "common/animations";

const Portfolio = lazy(() => import("./thirdRow/portfolio"));
const MemoizedTotalProperty = memo(TotalProperty);

const Card = styled.div`
  width: 100%;
  height: 100%;
  min-height: 200px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  padding: 0.5rem 0.7rem;
  @media (min-width: 640px) {
    padding: 1.2rem 1.7rem;
  }
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export default function Index() {

  return (
    <div className=" grid grid-cols-13 gap-6">
      <AnimatedBox
        entry="slide-down"
        className="col-span-13 2xl:col-span-8 tourguide-home-ninth-step"
      >
        <Card>
          <Suspense fallback={null}>
            <Portfolio />
          </Suspense>
        </Card>
      </AnimatedBox>
      <AnimatedBox
        className="col-span-13 2xl:col-span-5 tourguide-home-forth-step h-full"
        threshold={0.1}
      >
        <Card>
          <MemoizedTotalProperty />
        </Card>
      </AnimatedBox>
    </div>
  );
}
